import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { useApi, useClientOptions } from "@/hooks/useApi";
import { PageHeader, FilterBar, DataTable, StatusBadge, ErrorBox } from "@/components/common/ui-bits";
import { fmtDate, money, optionList, PROPOSAL_STATUSES } from "@/lib/format";

export default function Proposals() {
  const [f, setF] = useState({});
  const { data, loading, error } = useApi("/proposals", f);
  const clients = useClientOptions();
  const navigate = useNavigate();
  return (
    <div>
      <PageHeader title="Propuestas" subtitle="Con versiones, opciones y aceptación digital del cliente."
        actions={<Button onClick={() => navigate("/propuestas/nueva")} data-testid="new-proposal-button"><Plus className="mr-2 h-4 w-4" />Nueva propuesta</Button>} />
      <FilterBar values={f} onChange={setF} testid="proposals-filters" filters={[
        { key: "status", label: "Estado", options: optionList(PROPOSAL_STATUSES) }, { key: "client_id", label: "Cliente", options: clients }]} />
      <ErrorBox text={error} />
      <DataTable testid="proposals-table" quickView={(r) => `${r.number} · ${r.title}`} loading={loading} rows={data} onRowClick={(r) => navigate(`/propuestas/${r.id}`)} empty="No hay propuestas."
        columns={[
          { key: "number", label: "Número", render: (r) => <span className="num text-xs">{r.number}</span> },
          { key: "title", label: "Propuesta", render: (r) => <span className="font-medium text-slate-900">{r.title}<span className="block text-xs font-normal text-slate-500">{r.client_name}</span></span> },
          { key: "options", label: "Opciones", render: (r) => <span className="text-xs">{r.options.map((o) => `${o.name}: ${money(o.total)}`).join(" · ")}</span> },
          { key: "current_version", label: "Versión", render: (r) => `v${r.current_version}` },
          { key: "valid_until", label: "Vence", render: (r) => fmtDate(r.valid_until) },
          { key: "status", label: "Estado", render: (r) => <StatusBadge status={r.status} /> },
        ]} />
    </div>
  );
}
